<!-- 群星官网 -->
<template>
  <div class="update-mask" v-if="needUpdate">
    <div id="updateBrow">
      <div class="modal-body">
        <h4>你的浏览器版本太低啦，为了账户安全请使用Chrome浏览器</h4>
        <div id="chrome"></div>
        <div>Google Chrome</div>
        <span class="advantage">安全</span>
        <span class="advantage">兼容性好</span>
        <span class="advantage">简洁高效</span>
        <span class="advantage">速度快</span>
        <a href="/imgs/portal/home/Chrome_58.0.3029.110_Setup.exe" id="download" title="">下载正版</a> 
        <span class="suggest"><span class="warn">!</span>建议设为默认浏览器</span>
      </div>
      <div class="modal-footer">
        <p>群星温馨提示：使用低版本浏览器有哪些坏处呢？</p>
        <div class="disadvantage">
          <div id="safe"></div>
          <p>安全漏洞</p>
          <span>威胁账户安全</span>
        </div>
        <div class="disadvantage">
          <div id="match"></div>
          <p>不兼容</p>
          <span>页面内容显示不全</span>
        </div>
        <div class="disadvantage">
          <div id="pc"></div>
          <p>体验差</p>
          <span>界面排列错乱</span>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
function isLessThanIE10 () {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    var reg = /\d+\.0/
    var UA = navigator.userAgent
    var v = reg.exec(UA.split(';')[1])
    if (v && v < 10) {
      return true
    }
  }
  return false
}

export default {
  data () {
    return {
      needUpdate: false
    }
  },
  created () {
    if (isLessThanIE10()) {
      this.needUpdate = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/utils";
.update-mask{
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  #updateBrow{
    color:#717071;
    text-align: center;
    font-size: 14px;
    position: fixed;
    z-index: 9999;
    top: 1rem;
    left: 50%;
    width: 6rem;
    margin-left: -3rem;
    padding: 0.3rem 0;
    background-color: #fff;

    .modal-dialog{
      width: 647px;
      margin-top: 85px;
    }

    .modal-header,.modal-body {
      border-bottom: none;
      padding: 0;
    }
    .modal-header:after,.modal-footer:after{
      clear: both;
      content: '';
      display: block;
    }
    p,h4{
      color:#717071;
      margin: 0;
    }

    h4{
      font-size: 0.16rem;
    }

    #chrome{
      width: 0.5rem;
      height: 0.5rem;
      background-image:url(/imgs/portal/home/google_icon.png);
      margin: 0.24rem auto 0.1rem;

      @include media2x(url(/imgs/portal/home/google_icon@2x.png));
    }

    #download{
      width: 2.2rem;
      background-color: #4876cd;
      border: none;
      color: #fff;
      height: 0.45rem;
      display: block;
      margin: 0.1rem auto;
      border-radius: 6px;
      line-height: 0.45rem;
    }

    .advantage{
        margin: 0.1rem;
        display: inline-block;
        margin-top: 0.24rem;
    }

    .suggest{
        color: #aaa;
        font-size: 0.12rem;
        position: relative;
    }

    .warn{
      width: 0.12rem;
      height: 0.12rem;
      display: block;
      position: absolute;
      left: -0.16rem;
      top: 3px;
      background-color: #aaa;
      color: #fff;
      line-height: 0.12rem;
      border-radius: 0.06rem;
    }

    .modal-footer{
      margin-top: 0.3rem;
      background-color: #e1e7ed;
      text-align: center;
      padding: 0.2rem 1rem;
    }

    .disadvantage{
      float: left;
      font-size: 0.12rem;
      width: 1.2rem;

      p{
        font-size: 0.16rem;
      }

      #safe{
        width: 0.35rem;
        height: 0.4rem;
        margin: 0.1rem auto;
        background-image:url(/imgs/portal/home/safe_icon.png);

        @include media2x(url(/imgs/portal/home/safe_icon@2x.png));
      }

      #pc{
        width: 0.4rem;
        height: 0.4rem;
        margin: 0.1rem auto;
        background-image:url(/imgs/portal/home/pc_icon.png);

        @include media2x(url(/imgs/portal/home/pc_icon@2x.png));
      }

      #match{
        width: 0.38rem;
        height: 0.4rem;
        margin: 0.1rem auto;
        background-image:url(/imgs/portal/home/match_icon.png);

        @include media2x(url(/imgs/portal/home/match_icon@2x.png));
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// UpdateModal.vue?a9f37f3a